export default __webpack_public_path__ + "static/media/gallery_03.11970c1f.jpg";